import { IImage } from '../../../types/newbuildingHeader';
import { TMedia, EMediaType } from '../../Carousel';

export const prepareSlides = (images: IImage[]): TMedia[] => {
  return images.map(item => ({
    type: EMediaType.Photo,
    src: item.fullUrl,
  }));
};
